export enum DocumentStatusId {
  Draft = 1, // Черновик
  Paused = 2, // На паузе
  Running = 3, // Выполняется
  Expired = 4, // Просрочен
  Stopped = 5, // Остановлен
  Standard = 6, // Стандартный
}
